//
//
//
//
//
//
//

export default {
    name: "QfPValidationType",
    props: {
        value: { type: String },
        label: { type: String, default: "Type" },
        disable: { type: Boolean, default: false }
    },
    data() {
        return {
            localValue: "",
            options: [
                { label: this.$t("userInterface.properties.validationTxtOpt"), value: "text" },
                { label: this.$t("userInterface.properties.validationNumberOpt"), value: "number" },
                { label: this.$t("userInterface.properties.validationOthOpt"), value: "other" }
            ]
        };
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true
        }
    },
    methods: {
        updateValue(value) {
            this.$emit("input", value);
        }
    }
};
